<template>
  <div :class="isActive ? 'active': ''" class="btn-icon menu-toggle" @click="toggleClick">
    <svg-icon :style="{color: $store.state.theme.activeName==='block'? '#b1d3fb': '#606266',}" style="font-size:18px !important" icon-class="menu" />
  </div>
</template>

<script>
export default {
  computed: {
    isActive() {
      return this.$store.state.app.sidebarCollapse
    }
  },
  methods: {
    toggleClick() {
      this.$store.dispatch('app/toggleSideBar')
    }
  }
}
</script>

<style scoped>
.btn-icon {
  transform: rotate(0deg);
  transition: .38s;
  transform-origin: 50% 50%;
  cursor: pointer;
}

.btn-icon.active {
  transform: rotate(90deg);
}
</style>
